"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FABAutotrigger = void 0;
const cookie_1 = require("./cookie");
const button_1 = require("./button");
const just_detect_adblock_1 = require("just-detect-adblock");
const exit_intent_quattro_1 = require("exit-intent-quattro");
const responsive_js_1 = require("../../helper/responsive.js");
class FABAutotrigger {
    /** Init */
    init() {
        this.TimeDelay();
        this.ExitIntent();
        this.AdBlock();
    }
    /** Grab FAB by Type */
    static grabFAB(type) {
        let index = window.FAB_PLUGIN.to_display.findIndex((e) => e.trigger.type === type && responsive_js_1.FABHelperResponsive.check(e));
        if (index < 0)
            return false;
        let fab = window.FAB_PLUGIN.to_display[index];
        let cookieKeys = {
            adblock: `FABTriggerAdblock`,
            exit_intent: `FABTriggerExitIntent`,
            time_delay: `FABTriggerTimeDelay`,
        };
        let cookieKey = `${cookieKeys[type]}-${fab.ID}`;
        return { index, fab, cookieKey, cookie: cookie_1.FABCookie.getCookie(cookieKey) };
    }
    /** Do AutoTrigger */
    static autoTrigger(data) {
        let { index, fab, cookieKey, cookie } = data;
        /** Condition to Open Popup has been Opened / Not or expiration <= 0 */
        if (fab.trigger.triggered === undefined && (!cookie || fab.trigger.cookie.expiration <= 0)) {
            fab.trigger.triggered = true;
            window.FAB_PLUGIN.to_display[index].trigger.triggered = true;
            let delay = (fab.trigger.delay !== undefined) ? fab.trigger.delay.replace('ms', '') : 1000;
            setTimeout(() => {
                cookie_1.FABCookie.setCookie(cookieKey, 'true', fab.trigger.cookie.expiration, '/');
                button_1.FABButton.triggerClick(`fab-link-${fab.ID}`);
            }, delay);
        }
    }
    /** Time Delay */
    TimeDelay() {
        let data = FABAutotrigger.grabFAB('time_delay');
        if (!data) {
            return;
        }
        else
            FABAutotrigger.autoTrigger(data);
    }
    /** Exit Intent */
    ExitIntent() {
        const removeExitIntent = (0, exit_intent_quattro_1.default)({
            edges: {
                top: true,
                right: true,
                bottom: true,
                left: true,
            },
            threshold: 20,
            maxDisplays: 2,
            eventThrottle: 100,
            onExitIntent: ({ side, position: { x, y } }) => {
                let data = FABAutotrigger.grabFAB('exit_intent');
                if (!data) {
                    return;
                }
                else {
                    FABAutotrigger.autoTrigger(data);
                    setTimeout(function () { removeExitIntent(); }, 500);
                }
            },
        });
    }
    /** DetectAdBlock */
    AdBlock() {
        (0, just_detect_adblock_1.detectAnyAdblocker)().then((detected) => {
            if (detected) {
                let data = FABAutotrigger.grabFAB('adblock');
                if (!data) {
                    return;
                }
                else
                    FABAutotrigger.autoTrigger(data);
            }
        });
    }
}
exports.FABAutotrigger = FABAutotrigger;
